'use client';

import { useEffect, useRef, useState } from "react"
import { LuPlus } from "react-icons/lu"

export const FAQAccordion: React.FC<{
    index: number | null
    question: string
    answer: string | string[]
}> = ({ index, question, answer }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const contentRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (isOpen) {
            setHeight(contentRef.current ? contentRef.current?.scrollHeight + 48 : 0);
        } else {
            setHeight(0);
        }
    }, [isOpen]);

    return (
        <div className="flex flex-col items-start bg-white border border-[#CCCCCC] shadow-md rounded-md">            
            <div onClick={() => setIsOpen((prev) => !prev)} className="flex w-full cursor-pointer items-center justify-start gap-4 p-3">
                <button
                    className={`w-4 h-4 rounded-full flex items-center justify-center transition-all ${
                        isOpen
                            ? 'bg-gray rotate-45'
                            : 'bg-white border border-[#cccccc]'
                    }`}
                >
                    <LuPlus
                        className={isOpen ? 'text-white' : 'text-[#888888]'}
                    />
                </button>

                <div className="font-black text-[#111111] text-md">
                    {question}
                </div>

            </div>

            <div
                className={`transition-[height] duration-500 w-full ease-in-out overflow-hidden px-12 ${height ? 'border-t border-[#CCCCCC]' : ''}`}
                style={{ height: `${height}px` }}
            >
                <div ref={contentRef} className="mt-4 text-[#555555] text-lg">
                    {(typeof answer == "string" ? <p>{answer}</p> : answer.map((a, i)=> <p key={i}>{a}</p>))}
                </div>
            </div>
        </div>
    )
}